import { saveStateToStorage } from '../../../actions';
import { setCampaignPickerSorting as setCampaignPickerSortingAction } from '../actions';

// TODO: DEV-80067 migrate all saveToStorage action to generic solution
const setCampaignPickerSorting = sortOption => dispatch => {
    dispatch(setCampaignPickerSortingAction(sortOption));
    dispatch(saveStateToStorage());
};

export default setCampaignPickerSorting;
